import { render, staticRenderFns } from "./DisengageWrapper.vue?vue&type=template&id=6fdaa058"
import script from "./DisengageWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisengageWrapper.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports